export const defineCustomElement = (name: string, component: CustomElementConstructor) => {
    if (!customElements.get(name)) {
        customElements.define(name, component)
    }
}
